module.exports = __webpack_public_path__ + "img/leisure_2_tn.0b567252.jpg";